/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleEntity } from './RoleEntity';
import {
    RoleEntityFromJSON,
    RoleEntityFromJSONTyped,
    RoleEntityToJSON,
    RoleEntityToJSONTyped,
} from './RoleEntity';
import type { TenantEntity } from './TenantEntity';
import {
    TenantEntityFromJSON,
    TenantEntityFromJSONTyped,
    TenantEntityToJSON,
    TenantEntityToJSONTyped,
} from './TenantEntity';
import type { GroupEntity } from './GroupEntity';
import {
    GroupEntityFromJSON,
    GroupEntityFromJSONTyped,
    GroupEntityToJSON,
    GroupEntityToJSONTyped,
} from './GroupEntity';

/**
 * 
 * @export
 * @interface UserEntity
 */
export interface UserEntity {
    /**
     * ユーザーの有効・無効状態
     * @type {string}
     * @memberof UserEntity
     */
    status: UserEntityStatusEnum;
    /**
     * 区分
     * @type {string}
     * @memberof UserEntity
     */
    type: UserEntityTypeEnum;
    /**
     * ユーザーID
     * @type {string}
     * @memberof UserEntity
     */
    id: string;
    /**
     * テナント
     * @type {TenantEntity}
     * @memberof UserEntity
     */
    tenant: TenantEntity;
    /**
     * Eメール
     * @type {string}
     * @memberof UserEntity
     */
    email: string;
    /**
     * ユーザー名
     * @type {string}
     * @memberof UserEntity
     */
    name: string;
    /**
     * テナントごとのsupertokens userId
     * @type {string}
     * @memberof UserEntity
     */
    authId: string;
    /**
     * 所属グループ
     * @type {Array<GroupEntity>}
     * @memberof UserEntity
     */
    groups: Array<GroupEntity>;
    /**
     * ロール
     * @type {Array<RoleEntity>}
     * @memberof UserEntity
     */
    roles: Array<RoleEntity>;
    /**
     * 作成日時
     * @type {Date}
     * @memberof UserEntity
     */
    createdAt: Date;
    /**
     * 最終更新日時
     * @type {Date}
     * @memberof UserEntity
     */
    updatedAt: Date;
    /**
     * 作成ユーザー
     * @type {UserEntity}
     * @memberof UserEntity
     */
    createdBy: UserEntity;
    /**
     * 最終更新ユーザー
     * @type {UserEntity}
     * @memberof UserEntity
     */
    updatedBy: UserEntity;
    /**
     * ログイン時にパスワードの変更を求めるかどうか
     * @type {boolean}
     * @memberof UserEntity
     */
    shouldPasswordInitialize: boolean;
    /**
     * 
     * @type {object}
     * @memberof UserEntity
     */
    isAdmin: object;
}


/**
 * @export
 */
export const UserEntityStatusEnum = {
    Enabled: 'ENABLED',
    Disabled: 'DISABLED'
} as const;
export type UserEntityStatusEnum = typeof UserEntityStatusEnum[keyof typeof UserEntityStatusEnum];

/**
 * @export
 */
export const UserEntityTypeEnum = {
    Human: 'human',
    Service: 'service'
} as const;
export type UserEntityTypeEnum = typeof UserEntityTypeEnum[keyof typeof UserEntityTypeEnum];


/**
 * Check if a given object implements the UserEntity interface.
 */
export function instanceOfUserEntity(value: object): value is UserEntity {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenant' in value) || value['tenant'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('authId' in value) || value['authId'] === undefined) return false;
    if (!('groups' in value) || value['groups'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('shouldPasswordInitialize' in value) || value['shouldPasswordInitialize'] === undefined) return false;
    if (!('isAdmin' in value) || value['isAdmin'] === undefined) return false;
    return true;
}

export function UserEntityFromJSON(json: any): UserEntity {
    return UserEntityFromJSONTyped(json, false);
}

export function UserEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'type': json['type'],
        'id': json['id'],
        'tenant': TenantEntityFromJSON(json['tenant']),
        'email': json['email'],
        'name': json['name'],
        'authId': json['authId'],
        'groups': ((json['groups'] as Array<any>).map(GroupEntityFromJSON)),
        'roles': ((json['roles'] as Array<any>).map(RoleEntityFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'createdBy': UserEntityFromJSON(json['createdBy']),
        'updatedBy': UserEntityFromJSON(json['updatedBy']),
        'shouldPasswordInitialize': json['shouldPasswordInitialize'],
        'isAdmin': json['isAdmin'],
    };
}

export function UserEntityToJSON(json: any): UserEntity {
    return UserEntityToJSONTyped(json, false);
}

export function UserEntityToJSONTyped(value?: UserEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'type': value['type'],
        'id': value['id'],
        'tenant': TenantEntityToJSON(value['tenant']),
        'email': value['email'],
        'name': value['name'],
        'authId': value['authId'],
        'groups': ((value['groups'] as Array<any>).map(GroupEntityToJSON)),
        'roles': ((value['roles'] as Array<any>).map(RoleEntityToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'createdBy': UserEntityToJSON(value['createdBy']),
        'updatedBy': UserEntityToJSON(value['updatedBy']),
        'shouldPasswordInitialize': value['shouldPasswordInitialize'],
        'isAdmin': value['isAdmin'],
    };
}

